import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function Overview() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const stats = [
    { value: "12.5M", label: t("overview.stat.barrels"), suffix: "" },
    { value: "87%", label: t("overview.stat.transitShare"), suffix: "" },
    { value: "$145", label: t("overview.stat.oilPrice"), suffix: "/bbl" },
    { value: "4", label: t("overview.stat.nations"), suffix: "" },
  ];

  return (
    <section id="overview" className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/21d8b6b4c6bbb45a64de7b60f8c3e28b.jpg"
          alt="Saudi Arabia Oil Infrastructure"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0b0b0b]/70 via-[#0b0b0b]/60 to-[#0b0b0b]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0b0b0b]/50 via-transparent to-[#0b0b0b]/50" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-32 pb-20">
        <div className={`transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center gap-2 mb-6">
            <div className="w-8 h-[2px] bg-[#c9a84c]" />
            <span className="text-[#c9a84c] text-xs font-bold tracking-[4px] uppercase">
              {t("overview.badge")}
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6 max-w-4xl">
            {t("overview.line1")}<br />
            <span className="text-[#c9a84c]">{t("overview.line2")}</span><br />
            {t("overview.line3")}
          </h1>

          <p className="text-white/70 text-lg md:text-xl max-w-2xl mb-4 leading-relaxed">
            {t("overview.desc").split("<1>Saudi Aramco</1>").map((part, i) =>
              i === 0
                ? <span key={i}>{part}<strong className="text-white">Saudi Aramco</strong></span>
                : <span key={i}>{part}</span>
            )}
          </p>
          <p className="text-[#c9a84c]/80 text-base max-w-xl mb-10 leading-relaxed">
            {t("overview.subDesc")}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => document.querySelector("#contracts")?.scrollIntoView({ behavior: "smooth" })}
              className="bg-[#c9a84c] hover:bg-[#b8962e] text-[#0b0b0b] font-black text-base px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-[#c9a84c]/30"
            >
              {t("overview.viewContracts")} &rarr;
            </button>
            <button
              onClick={() => document.querySelector("#market")?.scrollIntoView({ behavior: "smooth" })}
              className="border border-white/30 hover:border-[#c9a84c] text-white hover:text-[#c9a84c] font-semibold text-base px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap"
            >
              {t("overview.marketAnalysis")}
            </button>
          </div>
        </div>

        <div className={`mt-20 grid grid-cols-2 md:grid-cols-4 gap-4 transition-all duration-1000 delay-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {stats.map((s) => (
            <div key={s.label} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-5 text-center">
              <p className="text-3xl md:text-4xl font-black text-[#c9a84c]">
                {s.value}<span className="text-lg">{s.suffix}</span>
              </p>
              <p className="text-white/60 text-xs mt-1 uppercase tracking-widest font-medium">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#c9a84c]/40 rounded-full flex items-start justify-center pt-2">
          <div className="w-1 h-2 bg-[#c9a84c] rounded-full" />
        </div>
      </div>
    </section>
  );
}
